// import Vue from 'vue';
// import VueI18n from 'vue-i18n';
// import locales from '../locales/index';
// import { getItem } from '@/utils/storage'

// Vue.use(VueI18n);

// export default new VueI18n({
//   locale: getItem('locale') ? getItem('locale') : 'ru',
//   fallbackLocale: 'ru',
//   messages: locales,
// });
import { createI18n } from 'vue-i18n';
import locales from '../locales/index';
import { getItem } from '@/utils/storage';


const i18n = createI18n({
  legacy: false,
  locale: getItem('locale') ? getItem('locale') : 'uz',
  fallbackLocale: 'uz',
  messages: locales,
});

export default i18n;
